"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderFormTypes = void 0;
var orderFormTypes = exports.orderFormTypes = {
  "default": 'default',
  advanced: 'advanced',
  block: 'block',
  buySell: 'buySell',
  futures: 'futures'
};